import { defineMessages } from 'react-intl';

export default defineMessages({
  integrationUpdateError: {
    id: 'app.containers.Integrations.integrationUpdateError',
    defaultMessage:
      'Your changes could not be saved. Please check the values and try again.',
  },
  credentialsValidationSuccess: {
    id: 'app.containers.Integrations.credentialsValidationSuccess',
    defaultMessage: 'Credentials successfully stored',
  },
  invalidCredentials: {
    id: 'app.containers.Integrations.invalidCredentials',
    defaultMessage:
      'Login credentials cannot be verified. Please check them and try again.',
  },
  invalidCorporationId: {
    id: 'app.containers.Integrations.invalidCorporationId',
    defaultMessage:
      'These credentials are for a different Bullhorn instance (corp ID {receivedId}) than the one currently linked (corp ID {currentId}). To switch instances, disconnect the current Bullhorn integration first.',
  },
  errorInvalidFile: {
    id: 'app.containers.Integrations.errorInvalidFile',
    defaultMessage:
      'The selected file cannot be fetched. Try adding the candidate without CV and upload it manually.',
  },
  deployMetadataError: {
    id: 'app.containers.Integrations.deployMetadataError',
    defaultMessage: 'Failed to deploy Salesforce components. Please try again.',
  },
});
